export default __webpack_public_path__ + "static/media/wippy_download_page_app_store_text_zh.0710a713.svg";